import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UrlQueryParamsBuilderService } from './url-query-params-builder.service';

@NgModule({
  imports: [CommonModule],
  providers: [UrlQueryParamsBuilderService],
})
export class SharedUrlQueryParamsBuilderModule {}
